import React from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import { HelpIcon, TourIcon, VideoCamIcon, PublicIcon } from "../iconography";
import { findFirstHrefFromChildren } from "../../../utils/utils";

const ICONS = {
  video: <VideoCamIcon fontSize="small" />,
  tour: <TourIcon fontSize="small" />,
  custom: <HelpIcon fontSize="small" />,
  default: <PublicIcon fontSize="small" />,
};

const getIcon = (href) => {
  if (href.match(/^video\b/i)) return ICONS.video;
  if (href.match(/^kbmedia\b/i)) return ICONS.video;
  if (href.match(/^tour\b/i)) return ICONS.tour;
  if (href.match(/^custom\b/i)) return ICONS.custom;
  return ICONS.default;
};

const useStyles = makeStyles(() => ({
  listItem: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  listItemIcon: {
    minWidth: "30px",
  },
}));

export const MarkdownListItem = ({ children }) => {
  const classes = useStyles();

  const href = findFirstHrefFromChildren(children);
  const icon = href ? getIcon(href) : null;

  return (
    <ListItem className={classes.listItem}>
      {icon && (
        <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
      )}
      <ListItemText>
        {!icon && "-"} {children}
      </ListItemText>
    </ListItem>
  );
};
